import React from "react";
import { BtnChiTiet } from "./ChucNang/ChiTiet/BtnChiTiet";
import { BtnSua } from "./ChucNang/Sua/BtnSua";
import { BtnMoKhoa } from "./ChucNang/MoKhoa/BtnMoKhoa";
import { BtnXoa } from "./ChucNang/Xoa/BtnXoa";

export const ContentTable = ({ listDanhSach, phanQuyen, onReload, dataSearch }) => {

    return (
        <>
            {listDanhSach.map((item, index) => (
                <div key={item.LoaiThuChiId} className="custom-table-row" style={{ minHeight: "56px", borderBottom: '1px solid #e0e0e0' }}>
                    <div className="custom-table-cell flex-basis-5" style={{ justifyContent: 'center', fontWeight: 500 }}>
                        <span className="mobile-column-name color7-bold">STT</span>
                        <div className="center-wrapper color7-bold text-center">
                            {index + 1 + (dataSearch.iPageIndex - 1) * (dataSearch.iPageSize || 20)}
                        </div>
                    </div>
                    <div className="custom-table-cell flex-basis-25 text-left" style={{ justifyContent: 'flex-start' }}>
                        <span className="mobile-column-name color7-bold">Tên loại phiếu</span>
                        <div className="center-wrapper">
                            <BtnChiTiet item={item} />
                        </div>
                    </div>
                    <div className="custom-table-cell flex-basis-15 text-left" style={{ justifyContent: 'flex-start' }}>
                        <span className="mobile-column-name color7-bold">Ngày tạo</span>
                        <div className="center-wrapper">
                            {item.CreatedTime ? item.CreatedTime.split(' ')[0] : ''}
                        </div>
                    </div>
                    <div className="custom-table-cell flex-basis-20 text-left" style={{ justifyContent: 'flex-start' }}>
                        <span className="mobile-column-name color7-bold">Người tạo</span>
                        <div className="center-wrapper">
                            {item.CreatedUser ? item.CreatedUser : ''}
                        </div>
                    </div>
                    <div className="custom-table-cell flex-basis-10 text-left" style={{ justifyContent: 'flex-start' }}>
                        <span className="mobile-column-name color7-bold">Loại</span>
                        <div className="center-wrapper">
                            {item.Type === 1 ? <span className="dang-vay" style={{ fontWeight: 500 }}>Thu</span> : <span className="canh-bao-red-v2" style={{ fontWeight: 500 }}>Chi</span>}
                        </div>
                    </div>
                    <div className="custom-table-cell flex-basis-15 text-left" style={{ justifyContent: 'flex-start' }}>
                        <span className="mobile-column-name color7-bold">Trạng thái</span>
                        <div className="center-wrapper">
                            {item.Status === 2 ? <span className="canh-bao-red-v2" style={{ fontWeight: 500 }}>Đã khóa</span> : <span className="dang-vay" style={{ fontWeight: 500 }}>Hoạt động</span>}
                        </div>
                    </div>
                    <div className="custom-table-cell flex-basis-10" style={{ justifyContent: 'center' }}>
                        <div className="center-wrapper text-center" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                            {item.Status === 1 && (
                                <React.Fragment>
                                    {!item.IsUsed && phanQuyen.sua && (
                                        <BtnSua item={item} onReload={onReload} />
                                    )}
                                    {phanQuyen.khoa && (
                                        <BtnMoKhoa item={item} onReload={onReload} type="khoa" />
                                    )}
                                    {!item.IsUsed && phanQuyen.xoa && (
                                        <BtnXoa item={item} title="Xóa phiếu" onReload={onReload} />
                                    )}
                                </React.Fragment>
                            )}
                            {item.Status === 2 && (
                                <React.Fragment>
                                    {!item.IsUsed && phanQuyen.sua && (
                                        <BtnSua item={item} onReload={onReload} />
                                    )}
                                    {phanQuyen.mo && (
                                        <BtnMoKhoa item={item} onReload={onReload} type="mokhoa" />
                                    )}
                                    {!item.IsUsed && phanQuyen.xoa && (
                                        <BtnXoa item={item} title="Xóa phiếu" onReload={onReload} />
                                    )}
                                </React.Fragment>
                            )}
                        </div>
                    </div>
                </div>
            ))}
        </>
    );
};